import { Cursor, Highlighter, Rectangle, PencilSimpleLine, ChatCenteredDots, Stamp } from "@phosphor-icons/react";

export const TOOLS = [
  { key: "select", label: "Auswählen", hint: "Markierungen anklicken, Text auswählen", icon: Cursor },
  { key: "highlight", label: "Textmarker", hint: "Text im Dokument markieren (bei Fotos: Bereich hervorheben)", icon: Highlighter },
  { key: "rect", label: "Rechteck", hint: "Bereich einrahmen (z. B. Schadenstelle)", icon: Rectangle },
  { key: "pen", label: "Stift", hint: "Freihand zeichnen", icon: PencilSimpleLine },
  { key: "pin", label: "Kommentar", hint: "Notizzettel an eine Stelle setzen", icon: ChatCenteredDots },
  { key: "stamp", label: "Stempel", hint: "Stempel platzieren", icon: Stamp },
];

export const COLORS = [
  { hex: "#FACC15", label: "Gelb" },
  { hex: "#4ADE80", label: "Grün" },
  { hex: "#60A5FA", label: "Blau" },
  { hex: "#F472B6", label: "Rosa" },
  { hex: "#D32F2F", label: "Rot" },
  { hex: "#1A2238", label: "Dunkel" },
];

export const STAMPS = [
  { key: "wichtig", label: "WICHTIG", color: "#D32F2F" },
  { key: "geprueft", label: "GEPRÜFT", color: "#16A34A" },
  { key: "streitig", label: "STREITIG", color: "#F59E0B" },
  { key: "erledigt", label: "ERLEDIGT", color: "#1A2238" },
];

export const SCHRIFTSATZ_KATEGORIEN = [
  { value: "schadenposition", label: "Schadenposition", color: "#D32F2F" },
  { value: "sachverhalt", label: "Sachverhalt / Unfall", color: "#1A2238" },
  { value: "anspruch", label: "Anspruch / Forderung", color: "#16A34A" },
  { value: "sonstige", label: "Sonstige", color: "#F59E0B" },
];

export const TYP_LABEL = { highlight: "Textmarker", rect: "Rechteck", pen: "Freihand", pin: "Kommentar", stamp: "Stempel" };

export const isDrawingTool = (tool, isImage) => ["rect", "pen", "pin", "stamp"].includes(tool) || (tool === "highlight" && isImage);

export const clamp01 = (v) => Math.max(0, Math.min(1, v));

export function bbox(a) {
  if (a.typ === "rect" || a.typ === "stamp") return a.rect;
  if (a.typ === "highlight") {
    const rs = a.rects?.length ? a.rects : a.rect ? [a.rect] : [];
    if (!rs.length) return null;
    const x = Math.min(...rs.map(r => r.x)), y = Math.min(...rs.map(r => r.y));
    const x2 = Math.max(...rs.map(r => r.x + r.w)), y2 = Math.max(...rs.map(r => r.y + r.h));
    return { x, y, w: x2 - x, h: y2 - y };
  }
  if (a.typ === "pen") {
    if (!a.path?.length) return null;
    const xs = a.path.map(p => p[0]), ys = a.path.map(p => p[1]);
    const x = Math.min(...xs), y = Math.min(...ys);
    return { x, y, w: Math.max(...xs) - x, h: Math.max(...ys) - y };
  }
  if (a.typ === "pin") return { x: a.pos.x - 0.01, y: a.pos.y - 0.01, w: 0.02, h: 0.02 };
  return null;
}

// Client-Rects einer Textauswahl relativ zur Seite normalisieren
export function selectionRects(pageEl) {
  const sel = window.getSelection?.();
  if (!sel || sel.rangeCount === 0 || sel.isCollapsed) return null;
  const text = sel.toString().trim();
  if (!text) return null;
  const pr = pageEl.getBoundingClientRect();
  if (!pageEl.contains(sel.anchorNode) && !pageEl.contains(sel.focusNode)) return null;
  const rects = [];
  for (let i = 0; i < sel.rangeCount; i++) {
    for (const r of Array.from(sel.getRangeAt(i).getClientRects())) {
      if (r.width < 1 || r.height < 1) continue;
      if (r.right < pr.left || r.left > pr.right || r.bottom < pr.top || r.top > pr.bottom) continue;
      rects.push({ x: clamp01((r.left - pr.left) / pr.width), y: clamp01((r.top - pr.top) / pr.height), w: Math.min(1, r.width / pr.width), h: Math.min(1, r.height / pr.height) });
    }
  }
  if (!rects.length) return null;
  // Zeilen zusammenfassen (gleiche y-Position)
  const merged = [];
  for (const r of rects.sort((a, b) => a.y - b.y || a.x - b.x)) {
    const last = merged[merged.length - 1];
    if (last && Math.abs(last.y - r.y) < 0.004 && r.x <= last.x + last.w + 0.01) {
      last.w = Math.max(last.x + last.w, r.x + r.w) - last.x;
      last.h = Math.max(last.h, r.h);
    } else merged.push({ ...r });
  }
  return { text, rects: merged.slice(0, 120) };
}
